import useRouterBreadcrumbs from '../hooks/useRouterBreadcrumbs.js';
import { bool, func } from 'prop-types';
import { RouteLink } from 'routes';
import { WestIcon, EastIcon } from 'components/icons';
import { STooltip } from 'components/index.js';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import styles from '../styles/RouterBreadcrumbs.module.css';
import useWebBRHistory from '../hooks/useWebBRHistory.js';
import SearchTrigger from 'components/commandPalette/SearchTrigger';
import OnboardingHelpButton from 'components/onboarding/OnboardingHelpButton';

/**
 * @component RouterBreadcrumbs
 * @param {Object} props
 * @param {boolean} props.isExpand
 * @param {function} props.onExpand
 * @returns {JSX.Element}
 */
function RouterBreadcrumbs({ open, onOpen, onClose, isMd }) {
	const state = useRouterBreadcrumbs();

	const { webBRState, webBRHandler } = useWebBRHistory();

	return (
		<main className={styles.breadcrumbs} data-tour="nav-breadcrumbs">
			{isMd && (
				<STooltip
					title="Menu"
					icon={
						open ? <MenuOpenIcon /> : <MenuIcon />
					}
					onClick={open ? onClose : onOpen}
				/>
			)}
			<div style={{ width: '10px', height: '5px' }} />

			{state.linkData.map((data) => (
				<RouteLink
					className={styles.link}
					key={data.label}
					to={data.link}
				>
					<div className={styles.arrow_right_outside}>
						<div className={styles.arrow_right_inside}>
							<p className={styles.label}>{data.label}</p>
						</div>
					</div>
				</RouteLink>
			))}
			<SearchTrigger />
			<OnboardingHelpButton />
		</main>
	);
}

RouterBreadcrumbs.propTypes = {
	isExpand: bool,
	onExpand: func,
};

export default RouterBreadcrumbs;
